import { BillingCycle } from '_gql'
import * as yup from 'yup'

import { accountingSoftware, annualRevenue } from '@sputnik/schema/creditApplication/businessInfo'
import { desiredCredit, expectedSpend } from '@sputnik/schema/creditApplication/financeInfo'
import { email, firstName, lastName } from '@sputnik/schema/creditApplication/person'

export const businessInfo = yup.object().shape({
  annualRevenue: annualRevenue.nullable(),
  accountingSoftware: accountingSoftware.nullable(),
})

const financeInfo = yup.object().shape({
  desiredCredit: desiredCredit.nullable(),
  expectedSpend: expectedSpend.nullable(),
})

const outsourcedAccountant = yup.object().shape({
  firstName: firstName.nullable(),
  lastName: lastName.nullable(),
  email: email.nullable(),
})

export const financeDetailsFormValidationSchema = yup.object().shape({
  billingCycle: yup.string().oneOf(Object.values(BillingCycle)).nullable(),
  businessInfo: businessInfo.nullable(),
  financeInfo: financeInfo.nullable(),
  hasOutsourcedAccountant: yup.string().default('NO'),
  outsourcedAccountant: outsourcedAccountant.nullable(),
  // This field is just so we can figure out if we should disable
  // the Yes / No options for having an outsourced accountant
  hasOutsourcedAccountantOriginalValue: yup.boolean().nullable(),
})

export type FinanceDetailsFormValidationSchema = yup.InferType<typeof financeDetailsFormValidationSchema>
